import React, { ReactElement } from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import StatusImpl from 'components/StatusPage'

export default function StatusPage(): ReactElement {
  return <StatusImpl />
}

export const Head = getDocumentHead({
  title: 'Configuration Status',
  description:
    'The Status Page is your one stop shop for all troubleshooting efforts, providing relevant set up and status details.',
})
